import React, { FC, useState } from 'react';
import { Dropdown } from 'antd';
import Icon, { LoadingOutlined } from '@ant-design/icons';
import { TriangleDownIcon, TriangleUpIcon } from 'components/Elements/CustomSVGIcon';
import { BookAccessButtonProps } from '../../types';
import './bookAccessButton.scss';

const BookAccessButton: FC<BookAccessButtonProps> = ({
    isVisitorRequest,
    isLoading = false,
    accessBookingAvailable = true,
    onBookVisitorRequest,
    onBookGeneralAccess,
    onBookGuarding,
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const actionButtonIcon = isDropdownOpen ? TriangleUpIcon : TriangleDownIcon;

    if (isVisitorRequest) {
        return (
            // data-tour lives on the component, not on `.book-access-button-container`:
            // SiteInfo renders a second container with that class for the admin
            // Incidents dropdown, so the class alone is not a unique anchor.
            <div className="book-access-button-container" data-tour="site-book-access">
                <button
                    type="button"
                    className={`book-button ${isLoading ? 'loading' : ''}`}
                    onClick={onBookVisitorRequest}
                    disabled={isLoading}
                    aria-busy={isLoading}>
                    {isLoading ? (
                        <>
                            <LoadingOutlined aria-hidden="true" />
                            {' Booking...'}
                        </>
                    ) : (
                        'Book Visitor Request'
                    )}
                </button>
            </div>
        );
    }

    const dropdownItems = [
        {
            key: 'general',
            label: 'General Visit',
            onClick: onBookGeneralAccess,
            disabled: isLoading || !accessBookingAvailable,
        },
        {
            key: 'guarding',
            label: 'Guarding',
            onClick: onBookGuarding,
            disabled: isLoading,
        },
    ];

    return (
        <div className="book-access-button-container" data-tour="site-book-access">
            <Dropdown
                menu={{ items: dropdownItems }}
                trigger={['click']}
                placement="bottomRight"
                align={{ offset: [0, 4] }}
                overlayClassName="book-access-dropdown"
                getPopupContainer={(trigger) => trigger.parentElement || document.body}
                onOpenChange={setIsDropdownOpen}
                disabled={isLoading}>
                <button
                    type="button"
                    className={`book-button ${isLoading ? 'loading' : ''}`}
                    disabled={isLoading}
                    aria-haspopup="menu"
                    aria-expanded={isDropdownOpen}
                    aria-busy={isLoading}>
                    {isLoading ? (
                        <>
                            <LoadingOutlined aria-hidden="true" />
                            {' Booking...'}
                        </>
                    ) : (
                        <>
                            Book Access
                            <Icon component={actionButtonIcon as React.ForwardRefExoticComponent<unknown>} aria-hidden="true" />
                        </>
                    )}
                </button>
            </Dropdown>
        </div>
    );
};

export default BookAccessButton;
